import hipaaLogo from "../assets/images/hippa.png";
import isoLogo from "../assets/images/iso-27001.png";
import soc2Logo from "../assets/images/badge-soc2-agb.png";
import rfiLogo from "../assets/images/429787224_806567321491091_4610061085543521764_n.jpg";
import charusatLogo from "../assets/images/CHARUSAT_NEW.6cad095d.png";
import parulUniversityLogo from "../assets/images/Parul-University-Logo.png";
import vierLogo from "../assets/images/VIER-Logo_15-08-2023.webp";
import msuLogo from "../assets/images/download.jpg";
import ictrdLogo from "../assets/images/ictrd_logo_1.jpg";
import rmaiLogo from "../assets/images/images (2).png";
import istdLogo from "../assets/images/istd-lOGO-copy-removebg-preview.png";
import microsoftpartner from "../assets/navbar/microsoftpartner.svg";
import aimaLogo from "../assets/partners/aima.svg";

const accreditationCards = [
  {
    title: "HIPAA",
    logo: hipaaLogo,
  },
  {
    title: "ISO 27001",
    logo: isoLogo,
  },
  {
    title: "SOC 2",
    logo: soc2Logo,
  },
];

const partnerCards = [
  // {
  //   title: "Microsoft Partner",
  //   logo: microsoftpartner,
  // },
  {
    title: "Parul University",
    logo: parulUniversityLogo,
  },
  {
    title: "MSU",
    logo: msuLogo,
  },
  {
    title: "ISTD",
    logo: istdLogo,
  },
  // {
  //   title: "IRCTC",
  //   description:
  //     "Public-sector collaboration support for scalable technology and operational enablement.",
  //   logo: irctcLogo,
  // },
  {
    title: "CHARUSAT",
    logo: charusatLogo,
  },
  {
    title: "VIER",
    logo: vierLogo,
  },
  {
    title: "ICTRD",
    logo: ictrdLogo,
  },
  {
    title: "RMAI",
    logo: rmaiLogo,
  },
  {
    title: "Research Foundation of India",
    logo: rfiLogo,
  },
  {
    title: "AIMA",
    logo: aimaLogo,
  },
];

const AccreditationsPartners = () => {
  return (
    <div className="w-full flex items-center justify-center pt-[80px] pb-[120px]">
      <div className="md:w-[90%] xs:w-[95%] flex flex-col lg:gap-[70px] md:gap-[50px] xs:gap-[40px]">
        {/* -------------------------------- Header -------------------------------- */}
        <div className="relative w-full flex items-center justify-center bg-service-bg bg-cover bg-center bg-no-repeat lg:rounded-[110px] sm:rounded-[67px] xs:rounded-[50px] 1400:py-[121px] lg:py-[80px] md:py-[60px] sm:py-[50px] xs:py-[30px] overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-r from-[#1FA2FF] from-[0%] via-25% to-[#A6FFCB] to-[70%] opacity-20 lg:rounded-[110px] sm:rounded-[67px] xs:rounded-[50px]"></div>
          <div className="relative lg:w-[calc(100%-220px)] md:w-[calc(100%-100px)] sm:w-[calc(100%-60px)] xs:w-[calc(100%-20px)] flex flex-col gap-[10px] text-center font-faustina text-[#EEEEEE]">
            <p className="font-bold lg:text-[50px] md:text-[40px] xs:text-[32px]">
              Accreditations & Partners
            </p>
          </div>
        </div>

        {/* -------------------------------- Content -------------------------------- */}
        <div className="flex flex-col lg:gap-[60px] md:gap-[45px] xs:gap-[35px]">
          {/* ----------------------------- Accreditations ----------------------------- */}
          <div className="flex flex-col gap-6">
            <p className="font-faustina font-bold md:text-[34px] xs:text-[26px] text-head-gradient">
              Accreditations
            </p>
            <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-6">
              {accreditationCards.map((card) => (
                <div
                  key={card.title}
                  className="rounded-2xl bg-gradient-to-r from-sky-500 via-cyan-300 to-teal-300 p-[2px]"
                >
                  <div className="rounded-2xl bg-black h-full px-6 py-7 flex flex-col items-center justify-center gap-4 min-h-[200px]">
                    <div className="w-full rounded-xl bg-white/95 px-4 py-4 flex items-center justify-center">
                      {card.logo ? (
                        <img
                          src={card.logo}
                          alt={`${card.title} logo`}
                          className="h-[96px] w-full object-contain"
                          loading="lazy"
                        />
                      ) : null}
                    </div>
                    <p className="font-faustina font-bold text-[20px] text-head-gradient text-center">
                      {card.title}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* -------------------------------- Partners -------------------------------- */}
          <div className="flex flex-col gap-6">
            <p className="font-faustina font-bold md:text-[34px] xs:text-[26px] text-head-gradient">
              Partners
            </p>
            <div className="grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-6">
              {partnerCards.map((card) => (
                <div
                  key={card.title}
                  className="rounded-2xl bg-gradient-to-r from-sky-500 via-cyan-300 to-teal-300 p-[2px]"
                >
                  <div className="rounded-2xl bg-black h-full px-5 py-6 flex flex-col items-center justify-center gap-4 min-h-[210px]">
                    <div className="w-full rounded-xl bg-white/95 px-4 py-4 flex items-center justify-center">
                      {card.logo ? (
                        <img
                          src={card.logo}
                          alt={`${card.title} logo`}
                          className="h-[80px] w-full object-contain"
                          loading="lazy"
                        />
                      ) : null}
                    </div>
                    <p className="font-faustina font-bold text-[18px] text-head-gradient text-center">
                      {card.title}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccreditationsPartners;
